require('./externalUrl.tpl.html');
require('./externalUrlController');

const ExternalUrlComponent = {
    templateUrl: '/landing/widget/externalUrl/externalUrl.tpl.html',
    controller: 'externalUrlController',
    bindings: {
        url: '<',
        titleLabel: '<',
        widgetConfig: '<'
    }
};

angular.module('umLanding')
    .component('uiExternalUrl', ExternalUrlComponent);
